import { Controller } from "@hotwired/stimulus"

const SECOND = 1000
const MINUTE = 60

// The server says how long is left, because a wait started on render
// would restart every time a wrong code re-renders the page.
export default class extends Controller {
  static targets = ["button", "wait"]
  static values = {
    seconds: Number,
    readyLabel: String,
    resendLabel: String,
    resendMinutesLabel: String,
    newCodeLabel: String,
    newCodeMinutesLabel: String
  }

  connect() {
    this.deadline = Date.now() + this.secondsValue * SECOND
    this.#draw()

    this.ticking = setInterval(() => this.#draw(), SECOND)
  }

  disconnect() {
    clearInterval(this.ticking)
  }

  #draw() {
    const left = this.#secondsLeft()

    this.#drawButton(left)
    this.#drawWait(left)

    if (left <= 0) clearInterval(this.ticking)
  }

  #drawButton(left) {
    this.buttonTarget.disabled = left > 0
    this.buttonTarget.textContent = left > 0
      ? this.#filled(this.resendLabelValue, this.resendMinutesLabelValue, left)
      : this.readyLabelValue
  }

  #drawWait(left) {
    if (!this.hasWaitTarget) return

    this.waitTarget.textContent = left > 0
      ? this.#filled(this.newCodeLabelValue,
          this.newCodeMinutesLabelValue, left)
      : ""
  }

  #filled(secondsLabel, minutesLabel, left) {
    if (left < MINUTE) return secondsLabel.replace("%{seconds}", left)

    return minutesLabel
      .replace("%{minutes}", Math.floor(left / MINUTE))
      .replace("%{seconds}", left % MINUTE)
  }

  // Counting down from a deadline rather than subtracting a second a
  // tick: a backgrounded tab is given far fewer ticks than seconds.
  #secondsLeft() {
    return Math.ceil((this.deadline - Date.now()) / SECOND)
  }
}
